module.exports = __webpack_public_path__ + "static/media/img16.f4ed7891.JPG";